import { createTheme } from "@mui/material/styles";
import type { Shadows } from "@mui/material/styles/shadows";

import { adminTokens } from "./adminTokens";

const { color, typeScale, radius, shadow } = adminTokens;

const highestRestingElevation = 7;
const elevationCount = 25;

// Shadows exist only as "card" (resting surfaces) and "raised" (overlays).
const shadowForElevation = (elevation: number) => {
  if (elevation === 0) return "none";
  if (elevation <= highestRestingElevation) return shadow.card;
  return shadow.raised;
};

const shadows = Array.from({ length: elevationCount }, (_, elevation) =>
  shadowForElevation(elevation)
) as Shadows;

export const adminTheme = createTheme({
  spacing: 4,
  shape: { borderRadius: radius.input },
  shadows,
  palette: {
    primary: {
      main: color.periwinkle,
      dark: color.periwinkleHover,
      contrastText: color.navy,
    },
    secondary: { main: color.navy, contrastText: color.surface },
    error: { main: color.errorStrong },
    warning: { main: color.warningStrong },
    success: { main: color.successStrong },
    info: { main: color.navy },
    text: { primary: color.navy, secondary: color.inkSoft },
    background: { default: color.canvas, paper: color.surface },
    divider: color.border,
  },
  components: {
    // The 4px spacing unit halves MUI's default accordion padding; these keep
    // the padding MUI intends (16px sides).
    MuiAccordionSummary: { styleOverrides: { root: { padding: "0 16px" } } },
    MuiAccordionDetails: { styleOverrides: { root: { padding: "8px 16px 16px" } } },
  },
  typography: {
    fontFamily: typeScale.body.fontFamily,
    h1: typeScale.pageTitle,
    h2: typeScale.keyFigure,
    h3: typeScale.cardHeading,
    body1: typeScale.body,
    subtitle1: typeScale.labelValue,
    overline: typeScale.eyebrow,
    caption: { ...typeScale.meta, color: color.inkSoft },
    button: { ...typeScale.labelValue, textTransform: "none" },
  },
});
